import useDrawerContext from "@contexts/drawerContext"
import { useNavigate } from "react-router-dom"
import useYesOrNo from "@hooks/useYesOrNo"
import { size } from '@styles/theme'

import { DeleteConversations } from '@components/layout/bottom_drawers/elements/DrawerActions'
import { DrawerButtonGroup, DrawerContents } from './elements/DrawerLayout'
import { ReportUser } from './elements/bottom_actions/ReportUser'
import { DrawerAvatarGroup } from './elements/DrawerAvatarGroup'
import { DrawerDisplayName } from './elements/DrawerDisplayName'
import { DrawerJoinedText } from './elements/DrawerJoinedText'
import {
  DeleteConversationButton,
  NearbyProfileButton,
  SocialProfileButton,
  DrawerCloseButton,
  ReportButton,
  // BlockButton,
} from './elements/DrawerButtons'

const MessagesBottomDrawerContents = ({ otherUser }) => {
  const [isDeleteDialogOpen, openDeleteDialog, closeDeleteDialog] = useYesOrNo('messages__delete-conversation')
  const [isReportModalOpen, openReportModal, closeReportModal] = useYesOrNo('messages__report-user')
  // const [isBlockDialogOpen, openBlockDialog, closeBlockDialog] = useYesOrNo('user-actions__block-user')
  const { closeBottomDrawer } = useDrawerContext()
  const navigate = useNavigate()

  const handleConversationDeletePromise = (promise) => {
    // handle what happens after conversation is deleted successfully
    promise?.then?.(() => {
      closeBottomDrawer()
      navigate(-1)
    })
  }

  const handleReportPromise = (promise) => {
    promise?.then?.(() => {
      closeBottomDrawer()
    })
  }

  // const handleBlockPromise = (promise) => {
  //   promise?.then?.(() => {
  //     closeBottomDrawer()
  //     navigate(-1)
  //   })
  // }

  return (
    <DrawerContents>
      <DeleteConversations
        isOpen={isDeleteDialogOpen}
        setClosed={closeDeleteDialog}
        handlePromise={handleConversationDeletePromise}
      />
      <ReportUser
        isOpen={isReportModalOpen}
        setClosed={closeReportModal}
        handlePromise={handleReportPromise}
        reportedUser={otherUser}
        reportedItem={otherUser}
        reportedType='User'
      />
      {/* <BlockUser
        isOpen={isBlockDialogOpen}
        setClosed={closeBlockDialog}
        handlePromise={handleBlockPromise}
        otherUser={otherUser}
      /> */}
      <DrawerCloseButton
        setClosed={closeBottomDrawer}
        style={{ marginLeft: size(3) }}
      />
      <DrawerAvatarGroup user={otherUser} />
      <DrawerDisplayName user={otherUser} />
      <DrawerJoinedText
        user={otherUser}
        style={{ marginLeft: size(5) }}
      />
      <DrawerButtonGroup style={{ paddingTop: size(1) }}>
        {otherUser?.nearbyUuid && <NearbyProfileButton user={otherUser} />}
        {!otherUser?.isAnonymous && <SocialProfileButton user={otherUser} />}
      </DrawerButtonGroup>
      <DrawerButtonGroup>
        <DeleteConversationButton
          onClick={openDeleteDialog}
        />
        <ReportButton onClick={openReportModal} />
      </DrawerButtonGroup>
      {/* <DrawerButtonGroup>
        <BlockButton
          onClick={openBlockDialog}
        />
        <ReportButton />
      </DrawerButtonGroup> */}
    </DrawerContents>
  )
}

export default MessagesBottomDrawerContents
